// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindDynamicBoolean } from "../schema";

export function serialize_KindDynamicBoolean_internal(value: KindDynamicBoolean): unknown {
  return ((value: "dynamicBoolean"): unknown => {
    return value;
  })(value);
}
export function serialize_KindDynamicBoolean(obj: KindDynamicBoolean): string {
  return renderJsonWithNumbersAsBigint(serialize_KindDynamicBoolean_internal(obj));
}
export function deserialize_KindDynamicBoolean_internal(value: unknown): ParserResult<KindDynamicBoolean> {
  return ((value: unknown): ParserResult<"dynamicBoolean"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/KindDynamicBoolean]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "dynamicBoolean":
        return { success: true, value: "dynamicBoolean" };
      default:
        return { success: false, reason: `[#/components/schemas/KindDynamicBoolean]: '${value}' expected to be enum, one of 'dynamicBoolean'.` };
    }
  })(value);
}
export function deserialize_KindDynamicBoolean(str: string): ParserResult<KindDynamicBoolean> {
  return deserialize_KindDynamicBoolean_internal(parseJsonWithNumbersAsBigint(str));
}
